/*----------------------------------
- PRODUCT FEATURE PAGES: LAYOUT COPY (SSOT)
----------------------------------*/

/**
 * The words of the layout the four feature pages share (`ProductFeaturePage`), as the shipped template wrote them:
 * the tabs' landmark, the FAQ title, the related links' band and the screener film's control. Each feature's own copy
 * is in `<feature>/pageContent.ts`; the parts the solutions pages share are in `marketingPage.ts`.
 *
 * @docs docs/features/website-product-feature-pages
 */

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const PRODUCT_FEATURE_PAGE_CHROME = {
    /** The hero tabs' landmark name (a `nav`, as shipped, so a crawler and a screen reader find the siblings). */
    tabsLabel: 'Product features',
    faqTitle: (featureName: string) => `Questions about ${featureName}`,
    /** The related links' band, the landmark the discovery journey reads ("Continue the workflow"). */
    relatedLabel: 'Continue the workflow',
    filmSectionLabel: 'Product motion',
    /** The hero's persona pair, the shipped `PersonaAuthCtaPair` labels (the mock keeps them). */
    personaCtas: { investor: "I'm an Investor", founder: "I'm a Founder" },
} as const;

/** The screener film's Pause / Play control, the shipped labels. */
export const SCREENER_FILM_COPY = {
    pause: 'Pause animation',
    play: 'Play animation',
    unavailable: 'Animation unavailable',
} as const;
